/**
 * KALKI VTO V8 — Files Query Version
 * Works with vto-proxy-FILES-QUERY.php
 * Loads history directly from Shopify Files API (no metafields)
 * WITH daily limit (15/day per customer) handling
 */
(function() {
  var PROXY = "http://api.kalkifashion.com/shopify-tryon/vto-proxy-all-store.php";
  var MODELS_KEY = "kalki_vto_models_history";
  var RESULTS_KEY = "kalki_vto_results_history";
  var MAX_M = 50, MAX_R = 50;
  
  var shopifyHistory = []; // History from Shopify Files

  var userImg = null, garmentImg = null, camStream = null, facing = "user";
  var customerId = window.customerId || null;
  
  function $(id) { return document.getElementById(id); }

  // Init
  if (document.readyState === "complete" || document.readyState === "interactive") { init(); }
  else { document.addEventListener("DOMContentLoaded", init); }
  
  function init() { 
    renderModels(); 
    loadShopifyHistory(); // Load from Shopify Files
  }
  
  // Load history from Shopify Files API
  async function loadShopifyHistory() {
    if (!customerId && !window.customerId) {
      renderResults(); // Just show localStorage
      return;
    }
    
    try {
      var cid = customerId || window.customerId;
      var response = await fetch(PROXY + "?shopify_files_action=get_history&customer_id=" + cid);
      
      if (response.ok) {
        var data = await response.json();
        if (data.success && data.history) {
          shopifyHistory = data.history;
          console.log("✅ Loaded " + data.history.length + " try-ons from Shopify Files");
          renderResults();
          return;
        }
      }
    } catch(e) {
      console.log("Shopify Files unavailable, using localStorage:", e.message);
    }
    
    // Fallback to localStorage
    renderResults();
  }

  // ── Events ──
  document.addEventListener("click", function(e) {
    if (e.target.closest("#kalki-vto-trigger-btn")) {
      e.preventDefault();
      var btn = e.target.closest("#kalki-vto-trigger-btn");
      var isLoggedIn = btn.getAttribute("data-customer-logged-in") === "true";
      
      if (!isLoggedIn) {
        // kwikpass changes starts
        kpHandleLogin(window.location.href);
        // kwikpass changes Ends
        // window.location.href = "/account/login?return_to=" + encodeURIComponent(window.location.pathname + window.location.search);
        return;
      }
      
      if (window.customerId) customerId = window.customerId;
      
      var m = $("kalki-vto-modal"); if (!m) return;
      m.style.display = "flex"; document.body.style.overflow = "hidden";
      
      window.dataLayer?.push({
        event: 'try-on',
        product: { item_id: window.productID, item_name: window.productTitle }
      });
      if (window.webengage) {
        webengage.track('try-on', { 
          "product_id": window.productID,
          "product_name": window.productTitle
        });
      }
      
      loadGarment(); 
      renderModels(); 
      loadShopifyHistory(); // Reload on modal open
      return;
    }
    
    if (e.target.closest("#kalki-vto-close-btn") || e.target.classList.contains("kvto-backdrop")) {
      e.preventDefault(); closeModal(); return;
    }
    if (e.target.closest("#vto-open-camera-btn")) {
      e.preventDefault(); e.stopPropagation(); openCam(facing); return;
    }
    if (e.target.closest("#vto-browse-btn")) {
      e.preventDefault(); e.stopPropagation();
      var fi = $("vto-file-input"); if (fi) fi.click(); return;
    }
    if (e.target.closest("#vto-flip-camera-btn")) {
      e.preventDefault(); e.stopPropagation();
      facing = facing === "user" ? "environment" : "user"; openCam(facing); return;
    }
    if (e.target.closest("#vto-capture-btn")) { e.preventDefault(); capture(); return; }
    if (e.target.closest("#vto-close-camera-btn")) { e.preventDefault(); e.stopPropagation(); closeCam(); return; }
    if (e.target.closest("#vto-change-photo-btn")) { e.preventDefault(); e.stopPropagation(); resetUpload(); return; }
    if (e.target.closest("#kalki-vto-generate-btn")) { e.preventDefault(); generate(); return; }
    if (e.target.closest("#vto-restart-btn")) {
      e.preventDefault();
      var rs = $("vto-result-stage"), ss = $("vto-studio-stage");
      if (rs) rs.style.display = "none"; if (ss) ss.style.display = "block";
      resetUpload(); renderModels(); loadShopifyHistory(); return;
    }
    if (e.target.closest("#vto-save-model-btn")) {
      e.preventDefault();
      if (userImg) {
        saveModel(userImg);
        renderModels();
        alert("Model photo saved to history!");
      } else {
        alert("No model photo to save.");
      }
      return;
    }
    if (e.target.closest("#vto-add-to-cart-btn")) { e.preventDefault(); addToCart(); return; }
    var dz = e.target.closest("#vto-dropzone");
    if (dz && !e.target.closest("button") && !e.target.closest("video") && !e.target.closest("a")) {
      var fi2 = $("vto-file-input"); if (fi2) fi2.click();
    }
  });

  document.addEventListener("change", function(e) {
    if (e.target.id === "vto-file-input" && e.target.files.length) handleFile(e.target.files[0]);
  });
  document.addEventListener("dragover", function(e) { if (e.target.closest("#vto-dropzone")) e.preventDefault(); });
  document.addEventListener("drop", function(e) {
    var dz = e.target.closest("#vto-dropzone");
    if (dz) { e.preventDefault(); if (e.dataTransfer.files.length) handleFile(e.dataTransfer.files[0]); }
  });

  // ── Camera ──
  async function openCam(fm) {
    var v = $("vto-video-feed"), c = $("vto-camera-container"), p = $("vto-upload-prompts");
    if (!v || !c || !p) return;
    killStream();
    try {
      camStream = await navigator.mediaDevices.getUserMedia({ 
        video: { facingMode: fm, width: { ideal: 720 }, height: { ideal: 960 } }, 
        audio: false 
      });
      v.srcObject = camStream; p.style.display = "none"; c.style.display = "flex";
    } catch (err) {
      if (fm === "environment") { facing = "user"; openCam("user"); }
      else alert("Camera unavailable. Please upload a photo.");
    }
  }
  function killStream() { if (camStream) { camStream.getTracks().forEach(function(t){t.stop();}); camStream = null; } }
  function closeCam() {
    killStream();
    var c = $("vto-camera-container"), p = $("vto-upload-prompts");
    if (c) c.style.display = "none"; if (p) p.style.display = "flex";
  }
  function capture() {
    var v = $("vto-video-feed"); if (!v) return;
    var cv = document.createElement("canvas"); cv.width = 600; cv.height = 800;
    var ctx = cv.getContext("2d");
    if (facing === "user") { ctx.translate(cv.width, 0); ctx.scale(-1, 1); }
    ctx.drawImage(v, 0, 0, cv.width, cv.height);
    userImg = cv.toDataURL("image/jpeg", 0.85);
    closeCam();
    showPreview(userImg);
    saveModel(userImg);
    renderModels();
  }

  // ── Models History ──
  function getModels() { try { return JSON.parse(localStorage.getItem(MODELS_KEY)) || []; } catch(e) { return []; } }
  function saveModel(b64) {
    try {
      var h = getModels().filter(function(x){return x!==b64;});
      h.unshift(b64); if (h.length>MAX_M) h=h.slice(0,MAX_M);
      localStorage.setItem(MODELS_KEY, JSON.stringify(h));
    } catch(e) {}
  }
  function delModel(i, ev) {
    if (ev) ev.stopPropagation();
    var h = getModels(); var rm = h.splice(i,1)[0];
    localStorage.setItem(MODELS_KEY, JSON.stringify(h));
    if (userImg === rm) resetUpload();
    renderModels();
  }
  function renderModels() {
    var sec = $("vto-models-history-section"), tray = $("vto-models-history-tray");
    if (!sec||!tray) return;
    var h = getModels();
    if (!h.length) { sec.style.display = "none"; return; }
    sec.style.display = "block"; tray.innerHTML = "";
    h.forEach(function(b64, i) {
      var t = document.createElement("div"); t.className = "kvto-thumb model-thumb";
      if (userImg === b64) t.classList.add("active");
      var img = document.createElement("img"); img.src = b64; t.appendChild(img);
      var d = document.createElement("button"); d.type="button"; d.className="kvto-thumb-del"; d.innerHTML="&times;";
      d.addEventListener("click", function(ev){delModel(i,ev);}); t.appendChild(d);
      t.addEventListener("click", function(){ userImg = b64; showPreview(b64); renderModels(); });
      tray.appendChild(t);
    });
  }

  // ── Results History (ONLY from Shopify Files) ──
  function getResults() {
    // ONLY use Shopify Files - no localStorage fallback
    return shopifyHistory;
  }
  
  function saveResult(b64) {
    // Still save to localStorage as backup/cache
    try {
      var h = JSON.parse(localStorage.getItem(RESULTS_KEY)) || [];
      h.unshift(b64);
      if (h.length>MAX_R) h=h.slice(0,MAX_R);
      localStorage.setItem(RESULTS_KEY, JSON.stringify(h));
    } catch(e) {}
  }
  
  function renderResults() {
    var sec = $("vto-results-history-section"), tray = $("vto-results-history-tray");
    if (!sec||!tray) return;
    var h = getResults();
    if (!h.length) { sec.style.display = "none"; return; }
    sec.style.display = "block"; tray.innerHTML = "";
    
    h.forEach(function(item, i) {
      var imageUrl = item.image_url || item;
      
      var t = document.createElement("div"); 
      t.className = "kvto-thumb result-thumb";
      
      var img = document.createElement("img"); 
      img.src = imageUrl;
      img.loading = "lazy";
      t.appendChild(img);
      
      // No delete button - files managed in Shopify Admin
      
      t.addEventListener("click", function(){
        var fi = $("vto-final-result-img"), rs = $("vto-result-stage"), ss = $("vto-studio-stage");
        if (fi) fi.src = imageUrl; 
        setDL(imageUrl);
        if (ss) ss.style.display = "none"; 
        if (rs) rs.style.display = "flex";
      });
      
      tray.appendChild(t);
    });
  }

  // ── Download ──
  function setDL(urlOrB64) {
    var lk = $("vto-download-link"); if (!lk) return;
    
    // If it's a CDN URL, download directly
    if (urlOrB64.startsWith("http")) {
      lk.href = urlOrB64;
      lk.download = "kalki-tryon-" + Date.now() + ".png";
      return;
    }
    
    // Otherwise treat as base64
    try {
      var p = urlOrB64.split(";base64,"), m = p[0].split(":")[1], bs = atob(p[1]);
      var ab = new ArrayBuffer(bs.length), ia = new Uint8Array(ab);
      for (var i=0;i<bs.length;i++) ia[i]=bs.charCodeAt(i);
      var blob = new Blob([ab],{type:m});
      lk.href = URL.createObjectURL(blob);
      lk.download = "kalki-tryon-" + Date.now() + ".png";
    } catch(err) { lk.href = urlOrB64; lk.download = "kalki-tryon.png"; }
  }

  // ── Limit message ──
  function showLimitMessage(msg) {
    var ls = $("vto-loading-stage"), ss = $("vto-studio-stage"), rs = $("vto-result-stage");
    if (rs) rs.style.display = "none";
    if (ss) ss.style.display = "none";
    if (ls) {
      ls.style.display = "flex";
      ls.innerHTML =
        '<div class="kvto-loader-wrap">' +
          '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#747380" stroke-width="1.5" style="margin-bottom:12px;">' +
            '<circle cx="12" cy="12" r="9"/><path stroke-linecap="round" d="M12 7v5l3 2"/>' +
          '</svg>' +
          '<h2>Daily Limit Reached</h2>' +
          '<p class="kvto-muted">' + msg + '</p>' +
          '<button type="button" id="vto-limit-close-btn" class="kvto-dark-btn" style="margin-top:16px;">Close</button>' +
        '</div>';
      var cb = $("vto-limit-close-btn");
      if (cb) cb.addEventListener("click", closeModal);
    } else {
      alert(msg);
    }
  }

  // ── Core ──
  function showPreview(b64) {
    var pi = $("vto-user-preview-img"), pc = $("vto-user-preview-container"), gb = $("kalki-vto-generate-btn");
    if (pi) pi.src = b64; if (pc) pc.style.display = "flex"; if (gb) gb.disabled = false;
  }
  function closeModal() {
    var m = $("kalki-vto-modal");
    if (m) { m.style.display = "none"; document.body.style.overflow = ""; closeCam(); resetState(); }
  }
  async function loadGarment() {
    var gi = $("vto-garment-img"); if (!gi) return;
    try {
      var u = gi.src + (gi.src.indexOf("?")!==-1?"&":"?") + "t=" + Date.now();
      var r = await fetch(u); var b = await r.blob();
      var rd = new FileReader(); rd.onloadend = function(){ garmentImg = rd.result; }; rd.readAsDataURL(b);
    } catch(e) {}
  }
  function handleFile(f) {
    if (!f.type.startsWith("image/")) { alert("Please upload a valid image."); return; }
    var rd = new FileReader();
    rd.onload = function(e) {
      var img = new Image();
      img.onload = function() {
        var cv = document.createElement("canvas"); cv.width=600; cv.height=800;
        cv.getContext("2d").drawImage(img,0,0,600,800);
        userImg = cv.toDataURL("image/jpeg",0.85);
        showPreview(userImg);
        saveModel(userImg);
        renderModels();
      };
      img.src = e.target.result;
    };
    rd.readAsDataURL(f);
  }
  function resetUpload() {
    userImg = null;
    var pi=$("vto-user-preview-img"), pc=$("vto-user-preview-container"), fi=$("vto-file-input"), gb=$("kalki-vto-generate-btn");
    if (pi) pi.src=""; if (pc) pc.style.display="none"; if (fi) fi.value=""; if (gb) gb.disabled=true;
    renderModels();
  }
  
  async function generate() {
    if (!userImg || !garmentImg) { alert("Please upload or capture a photo first."); return; }
    var ss=$("vto-studio-stage"), ls=$("vto-loading-stage"), rs=$("vto-result-stage"), fi=$("vto-final-result-img");
    if (ss) ss.style.display="none"; if (ls) ls.style.display="flex";
    
    saveModel(userImg);
    renderModels();
    
    try {
      var currentCustomerId = customerId || window.customerId || null;
      var r = await fetch(PROXY, { 
        method:"POST", 
        headers:{"Content-Type":"application/json"},
        body: JSON.stringify({ 
          personImage: userImg, 
          garmentImage: garmentImg,
          customerId: currentCustomerId
        })
      });
      
      var d;
      try { d = await r.json(); } catch(e) { d = null; }

      // Daily limit reached (HTTP 429 with limit_reached flag)
      if (r.status === 429 && d && d.error === "limit_reached") {
        showLimitMessage(d.message || "You've reached your daily try-on limit. Please come back tomorrow!");
        return;
      }

      if (!r.ok) throw new Error((d && d.error) || "Generation failed.");
      
      if (d && d.success && d.image) {
        if (fi) fi.src = d.image;
        if (ls) ls.style.display = "none"; if (rs) rs.style.display = "flex";
        setDL(d.image); saveResult(d.image);
        
        // Upload to Shopify Files API
        if (customerId || window.customerId) {
          var gi = $("vto-garment-img");
          uploadToShopifyAndSave(d.image, {
            id: window.productID,
            title: window.productTitle,
            image: gi ? gi.src : ''
          });
        }
      } else { 
        throw new Error((d && d.error) || "Generation failed."); 
      }
    } catch(err) {
      alert("Try-On Failed: " + err.message);
      if (ls) ls.style.display="none"; if (ss) ss.style.display="block";
    }
  }
  
  // Shopify Files API Upload (with duplicate prevention)
  var uploadInProgress = false;
  
  async function uploadToShopifyAndSave(imageData, productData) {
    // Prevent duplicate uploads
    if (uploadInProgress) {
      console.log("⏸️ Upload already in progress, skipping duplicate");
      return;
    }
    
    uploadInProgress = true;
    
    try {
      var currentCustomerId = customerId || window.customerId;
      if (!currentCustomerId) {
        uploadInProgress = false;
        return;
      }
      
      var response = await fetch(PROXY + "?shopify_files_action=upload_and_save", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          image: imageData,
          customer_id: currentCustomerId,
          product_id: productData.id,
          product_title: productData.title,
          product_image: productData.image
        })
      });
      
      if (response.ok) {
        var result = await response.json();
        if (result.success) {
          console.log("✅ Saved to Shopify:", result.image_url);
          loadShopifyHistory(); // Reload history after successful upload
        }
      }
    } catch (err) {
      console.error("Shopify upload failed:", err);
    } finally {
      // Reset flag after 2 seconds to allow next upload
      setTimeout(function() {
        uploadInProgress = false;
      }, 2000);
    }
  }
  
  async function addToCart() {
    var vi = document.querySelector('[name="id"]'); if (!vi) { alert("Variant not found."); return; }
    try {
      var r = await fetch("/cart/add.js", { method:"POST", headers:{"Content-Type":"application/json"},
        body: JSON.stringify({ items:[{id:parseInt(vi.value),quantity:1}] })
      });
      if (r.ok) { setTimeout(function(){window.location.href="/cart";},800); }
    } catch(e) { closeModal(); var sb=document.querySelector('[type="submit"][name="add"]'); if(sb)sb.click(); }
  }
  
  function resetState() {
    var ss=$("vto-studio-stage"), ls=$("vto-loading-stage"), rs=$("vto-result-stage");
    if (ss) ss.style.display="block"; if (ls) ls.style.display="none"; if (rs) rs.style.display="none";
    resetUpload();
  }
})();